import { useQuery } from '@tanstack/react-query';
import { fetchSmriqContext } from '../services/smriq';

export const smriqContextKeys = {
    all: ['smriq', 'context'] as const,
    detail: (productId: string) => [...smriqContextKeys.all, productId] as const,
};

/** The only GET, and the only cacheable call in the journey. Backend already caches
 *  for 1h (SmriqJourneyController); staleTime here only stops refetch-on-focus. */
export function useSmriqContext(productId: string | undefined) {
    return useQuery({
        queryKey: smriqContextKeys.detail(productId ?? ''),
        queryFn: () => fetchSmriqContext(productId as string),
        enabled: !!productId,
        staleTime: 5 * 60_000,
    });
}
